import { type RootState } from '../store'

export default function selectIdToken(state: RootState): string {
  return state.auth.idToken
}
